export const mockUser = {
  id: "u1",
  name: "Chukwuemeka Obi",
  email: "emeka.obi@gmail.com",
  phone: "+234 812 345 6789",
  bvn: "**********3",
  kycStatus: "verified",
  nairaBalance: 184520.75,
  referralCode: "NAIRAX-EMK01",
};

export const mockCryptoHoldings = [
  {
    id: "h1",
    symbol: "BTC",
    name: "Bitcoin",
    amount: 0.00412,
    valueNGN: 287450.12,
    valueUSD: 185.4,
    change24h: 2.34,
    color: "#F7931A",
    icon: "ri-bit-coin-line",
  },
  {
    id: "h2",
    symbol: "ETH",
    name: "Ethereum",
    amount: 0.1845,
    valueNGN: 98200.50,
    valueUSD: 63.4,
    change24h: -1.12,
    color: "#627EEA",
    icon: "ri-currency-line",
  },
  {
    id: "h3",
    symbol: "USDT",
    name: "Tether",
    amount: 245.00,
    valueNGN: 381725.00,
    valueUSD: 245.0,
    change24h: 0.01,
    color: "#26A17B",
    icon: "ri-money-dollar-circle-line",
  },
  {
    id: "h4",
    symbol: "BNB",
    name: "BNB",
    amount: 0.34,
    valueNGN: 85340.00,
    valueUSD: 55.1,
    change24h: 1.87,
    color: "#F3BA2F",
    icon: "ri-coin-line",
  },
  {
    id: "h5",
    symbol: "SOL",
    name: "Solana",
    amount: 1.2,
    valueNGN: 45120.00,
    valueUSD: 29.1,
    change24h: -3.45,
    color: "#9945FF",
    icon: "ri-flashlight-line",
  },
];

export const mockCryptoAssets = [
  {
    symbol: "BTC",
    name: "Bitcoin",
    priceNGN: 69768956.00,
    priceUSD: 45020.00,
    change24h: 2.34,
    color: "#F7931A",
    marketCap: "₦870T",
    network: "Bitcoin Network",
  },
  {
    symbol: "ETH",
    name: "Ethereum",
    priceNGN: 5322180.00,
    priceUSD: 3435.00,
    change24h: -1.12,
    color: "#627EEA",
    marketCap: "₦255T",
    network: "ERC-20",
  },
  {
    symbol: "USDT",
    name: "Tether",
    priceNGN: 1558.00,
    priceUSD: 1.00,
    change24h: 0.01,
    color: "#26A17B",
    marketCap: "₦120T",
    network: "TRC-20 / ERC-20",
  },
  {
    symbol: "BNB",
    name: "BNB",
    priceNGN: 251000.00,
    priceUSD: 162.00,
    change24h: 1.87,
    color: "#F3BA2F",
    marketCap: "₦23T",
    network: "BEP-20",
  },
  {
    symbol: "SOL",
    name: "Solana",
    priceNGN: 37600.00,
    priceUSD: 24.25,
    change24h: -3.45,
    color: "#9945FF",
    marketCap: "₦11T",
    network: "Solana Network",
  },
  {
    symbol: "XRP",
    name: "XRP",
    priceNGN: 890.00,
    priceUSD: 0.574,
    change24h: 0.89,
    color: "#00AAE4",
    marketCap: "₦50T",
    network: "XRP Ledger",
  },
  {
    symbol: "DOGE",
    name: "Dogecoin",
    priceNGN: 247.00,
    priceUSD: 0.159,
    change24h: 5.21,
    color: "#C2A633",
    marketCap: "₦23T",
    network: "Dogecoin Network",
  },
  {
    symbol: "ADA",
    name: "Cardano",
    priceNGN: 720.00,
    priceUSD: 0.464,
    change24h: -0.73,
    color: "#0033AD",
    marketCap: "₦16T",
    network: "Cardano Network",
  },
];

export const mockWalletAddresses = [
  {
    symbol: "BTC",
    address: "bc1qxy2kgdygjrsqtzq2n0yrf2493p83kkfjhx0wlh",
    network: "Bitcoin Network",
    confirmations: 3,
  },
  {
    symbol: "ETH",
    address: "0x742d35Cc6634C0532925a3b8D4C9B2eA7c3f5d9b",
    network: "ERC-20",
    confirmations: 12,
  },
  {
    symbol: "USDT",
    address: "TQn9Y2khEsLJW1ChVWFMSMeRDow5KcbLSE",
    network: "TRC-20",
    confirmations: 20,
  },
  {
    symbol: "BNB",
    address: "bnb1grpf0955h0ykzq3ar5nmum7y6gdfl6lxfn46h2",
    network: "BEP-20",
    confirmations: 15,
  },
  {
    symbol: "SOL",
    address: "7xKXtg2CW87d97TXJSDpbD5jBkheTqA83TZRuJosgAsU",
    network: "Solana Network",
    confirmations: 32,
  },
];

export const mockTransactions = [
  {
    id: "tx1",
    type: "buy",
    asset: "BTC",
    assetName: "Bitcoin",
    cryptoAmount: 0.00105,
    nairaAmount: 75000,
    status: "completed",
    date: "2026-04-08T10:23:00Z",
    txHash: "a1b2c3d4e5f6789012345678",
    paymentMethod: "Paystack",
    rate: 71428571,
  },
  {
    id: "tx2",
    type: "deposit",
    asset: "USDT",
    assetName: "Tether",
    cryptoAmount: 100.00,
    nairaAmount: 155800,
    status: "completed",
    date: "2026-04-07T15:40:00Z",
    txHash: "f9e8d7c6b5a4321098765432",
    network: "TRC-20",
    rate: 1558,
  },
  {
    id: "tx3",
    type: "sell",
    asset: "ETH",
    assetName: "Ethereum",
    cryptoAmount: 0.05,
    nairaAmount: 266109,
    status: "completed",
    date: "2026-04-06T09:15:00Z",
    txHash: "1234abcd5678efgh9012ijkl",
    bankName: "GTBank",
    accountNumber: "***6789",
    rate: 5322180,
  },
  {
    id: "tx4",
    type: "withdraw_naira",
    asset: "NGN",
    assetName: "Naira",
    cryptoAmount: 0,
    nairaAmount: 50000,
    status: "completed",
    date: "2026-04-05T11:30:00Z",
    txHash: "",
    bankName: "Access Bank",
    accountNumber: "***4521",
    rate: 0,
  },
  {
    id: "tx5",
    type: "withdraw_crypto",
    asset: "BNB",
    assetName: "BNB",
    cryptoAmount: 0.2,
    nairaAmount: 50200,
    status: "pending",
    date: "2026-04-04T18:05:00Z",
    txHash: "pending...",
    network: "BEP-20",
    walletAddress: "0xAb5801a7D398351b8bE11C439e05C5B3259aeC9B",
    rate: 251000,
  },
  {
    id: "tx6",
    type: "buy",
    asset: "SOL",
    assetName: "Solana",
    cryptoAmount: 2.65,
    nairaAmount: 100000,
    status: "completed",
    date: "2026-04-03T13:20:00Z",
    txHash: "xyz987abc654def321ghi000",
    paymentMethod: "Paystack",
    rate: 37736,
  },
  {
    id: "tx7",
    type: "deposit",
    asset: "BTC",
    assetName: "Bitcoin",
    cryptoAmount: 0.0015,
    nairaAmount: 104653,
    status: "processing",
    date: "2026-04-02T07:45:00Z",
    txHash: "9876543210abcdef12345678",
    network: "Bitcoin Network",
    confirmations: "1/3",
    rate: 69768956,
  },
];

export const mockBanks = [
  { code: "058", name: "Guaranty Trust Bank" },
  { code: "044", name: "Access Bank" },
  { code: "011", name: "First Bank" },
  { code: "033", name: "UBA" },
  { code: "057", name: "Zenith Bank" },
  { code: "032", name: "Union Bank" },
  { code: "070", name: "Fidelity Bank" },
  { code: "050", name: "Ecobank" },
  { code: "076", name: "Polaris Bank" },
  { code: "039", name: "Stanbic IBTC" },
  { code: "035", name: "Wema Bank" },
  { code: "221", name: "Stanbic Mobile" },
  { code: "090115", name: "Opay" },
  { code: "090405", name: "Moniepoint" },
  { code: "090267", name: "Kuda Bank" },
  { code: "000026", name: "Carbon (Paylater)" },
];
